import { Dispatch, FC, RefObject, SetStateAction } from 'react';
import { SkillAncestries, SkillAncestriesId } from '../../models/SkillAncestries';
import SingleUnitSupportSkillsCard from './SingleUnitSupportSkillsCard';
import { Skill } from '../../models/Skill';
import { TieredMenu } from 'primereact/tieredmenu';
import { MenuItem } from 'primereact/menuitem';
import { SelectAssignmentModeModal } from '../../models/Assignment';
interface Props {
  skillAncestries: SkillAncestries[];
  skillTypeUnit: Skill[];
  tieredMenuRef: RefObject<TieredMenu>;
  setItemsTieredMenu: (i: MenuItem[]) => void;
  targetSkillsIds: string[];
  selectedStandardIds?: string[];
  setCreateAssignmentModal: Dispatch<SetStateAction<SelectAssignmentModeModal>>;
}

const SingleUnitSupportSkillsContainer: FC<Props> = ({
  skillTypeUnit,
  skillAncestries,
  tieredMenuRef,
  setItemsTieredMenu,
  targetSkillsIds,
  selectedStandardIds,
  setCreateAssignmentModal,
}) => {
  const mediumRelevance = skillAncestries.filter(skill => skill.skillRelevance.id === SkillAncestriesId.MEDIUM);
  const highRelevance = skillAncestries.filter(skill => skill.skillRelevance.id === SkillAncestriesId.HIGH);

  return (
    <div className="flex flex-column gap-lg align-items-center">
      {highRelevance && (
        <SingleUnitSupportSkillsCard
          skillTypeUnit={skillTypeUnit}
          arrayRelevance={highRelevance}
          nameRelevance="Essential"
          tieredMenuRef={tieredMenuRef}
          setItemsTieredMenu={setItemsTieredMenu}
          targetSkillsIds={targetSkillsIds}
          selectedStandardIds={selectedStandardIds}
          setCreateAssignmentModal={setCreateAssignmentModal}
        />
      )}
      {mediumRelevance && (
        <SingleUnitSupportSkillsCard
          skillTypeUnit={skillTypeUnit}
          arrayRelevance={mediumRelevance}
          nameRelevance="Helpful"
          tieredMenuRef={tieredMenuRef}
          setItemsTieredMenu={setItemsTieredMenu}
          targetSkillsIds={targetSkillsIds}
          selectedStandardIds={selectedStandardIds}
          setCreateAssignmentModal={setCreateAssignmentModal}
        />
      )}
    </div>
  );
};

export default SingleUnitSupportSkillsContainer;
